import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { creLoginRequest } from "./creAuthConfig";
import { setCreLoginIntent } from "./creLoginIntent";
import { getCreMsalInstance } from "./creMsalInstance";

export default function CreLoginPage() {
  const { inProgress } = useMsal();
  const loading = inProgress !== InteractionStatus.None;

  const handleSignIn = () => {
    setCreLoginIntent("enterprise");
    getCreMsalInstance().loginRedirect(creLoginRequest);
  };

  return (
    <div className="cre-root cre-login-page">
      <div className="cre-login-bg" aria-hidden />
      <div className="cre-login-grid" aria-hidden />
      <div className="cre-login-card">
        <h1 className="cre-login-title">Organization Sign In</h1>
        <p className="cre-login-sub">
          Sign in with your organization&apos;s Microsoft account to access CRE.
        </p>
        <button
          type="button"
          className="cre-btn-signin"
          disabled={loading}
          onClick={handleSignIn}
        >
          {loading ? "Signing in…" : "Sign in"}
        </button>
        <p className="cre-login-note">
          Your email domain must be registered by your administrator.
        </p>
      </div>
    </div>
  );
}
